export default __webpack_public_path__ + "fonts/inter-latin-600-normal.ee12ccf9091a8c14bf3a.woff2";